import React, { useContext, useState } from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ThemeContext } from '../../../../../utils/themeContext';
import { createReservation } from '../../../../../utils/requests';
import { AxiosResponse } from 'axios';
import { AppContext } from '../../../../../utils/appContext';

const Card = () => {
  const appContext = useContext(AppContext);
  const { t } = useTranslation();
  let history = useHistory();

  const theme = useContext(ThemeContext);

  const useStyles = makeStyles()((theme) => {
    return {
      paymentContainer: {
        textAlign: 'center',
        padding: '6px 0',
        cursor: 'pointer',
        minHeight: 20,
        display: 'flex',
        backgroundColor: '#ffffff',
        border: '1px solid #555',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '4px!important',
        '&:hover': {
          borderColor: theme.palette.primary.main
        },
        '& i': {
          fontSize: 30,
          alignItems: 'center',
          display: 'inline-flex'
        },
        '& img': {
          alignItems: 'center',
          display: 'flex'
        }
      }
    };
  });

  const { classes } = useStyles();

  const [loading, setLoading] = useState<boolean>(false);
  const [isBtnPayDisabled, setIsPayButtonDisabled] = useState<boolean>(false);

  const createOrder = () => {
    appContext.setBackdropIsOpen(true);
    setIsPayButtonDisabled(true);
    createReservation(appContext.orders)
      .then((response: AxiosResponse) => {
        console.log(response);
        if (response.status && response.data.url) {
          if (response.data.data) {
            localStorage.setItem('orders', JSON.stringify(response.data.data));
          }
          window.location.href = response.data.url;
        }

        if (response.status && response.data.status && response.data.status === 'booked') {
          if (response.data.data) {
            localStorage.setItem('orders', JSON.stringify(response.data.data));
          }
          history.push('/accepted');
          appContext.setBackdropIsOpen(false);
        }
      })
      .catch(() => {
        setIsPayButtonDisabled(false);
        appContext.setBackdropIsOpen(false);
        history.push('/denied');
      });
  };

  const insertReservation = (event: any) => {
    event.preventDefault();
    createOrder();
  };

  return (
    <Grid item xs={12}>
      <Box sx={{ marginBottom: 5 }}>
        <Grid container direction="row" justifyContent="center" alignItems="flex-start">
          <Box sx={{ width: '100%' }}>
            <Paper className={classes.paymentContainer} onClick={insertReservation}>
              <i className="las la-credit-card"></i>
              <Box pl={1}>
                <Typography component={'p'} variant={'h6'}>
                  {t('Paga tramite Banca Sella')}
                </Typography>
              </Box>
            </Paper>
          </Box>
        </Grid>
      </Box>
    </Grid>
  );
};

export default Card;
